module.exports = __webpack_public_path__ + "static/media/shape_6.0ff19bc2.png";